import EnrolmentsAdapter from './base';

export default class Enrolment extends EnrolmentsAdapter {
  modelNamePlural = 'enrolments';
}
